import { memo } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { dom } from 'app/utils';
import { Breadcrumb } from 'app/components';
import { Button } from 'app/components/common'
import { Form, Row } from 'app/components/layout'
import { IReport } from 'app/models';

import { ProfileView } from './views';
import { Field, TextArea } from '../../components/form';

export default memo(() => {
  const { t } = useTranslation();

  const model = useLoaderData() as IReport;
  const user = model.user, profile = user?.profile;

  const form: any = {
    className: dom.className('p-4', 'flex-auto', 'overflow-auto'),
  };

  return (
    <div className="h-full flex flex-column align-items-stretch">
      <div className="flex-none flex surface-200">
        <Breadcrumb className="flex-auto border-none border-noround bg-transparent" />
        <div className="flex flex-none m-2">
          <Button text severity="warning" href=".." icon="pi-times" label={t('app.cancel')} className="mr-2 px-3 py-1" />
        </div>
      </div>
      <div { ...form }>
        <Form responsive={true}>
          <Row>
            <div className="p-3 flex-1">
              <ProfileView profileId={profile?.id} />
            </div>
            <div className="p-3 flex-1">
              <Field text={t('reports.fields.description')} align="end" asterisk>
                <TextArea value={model.description} style={{ height: '6rem' }} disabled />
              </Field>
            </div>
          </Row>
        </Form>
      </div>
    </div>
  );
});
